import { inject, Injectable, signal } from '@angular/core';
import { IExam } from '../interfaces/IExam';
import { db } from '../db/AppDatabase';
import { ExamSessionService } from '../_Services/apih/exam-session-service';
import { firstValueFrom } from 'rxjs';
import { IExamSession } from '../_Models/iexam-session';

@Injectable({ providedIn: 'root' })
export class ExamsService {

  private _exams = signal<IExam[]| null>(null);
  public Exams = this._exams.asReadonly();
  private _pastExams = signal<IExam[] | null>(null);
  public PastExams = this._pastExams.asReadonly();

  public examsFromAPI = inject(ExamSessionService);
 
  constructor() {
    this.loadUpcomingExams();
  }

  async loadUpcomingExams() {
    this._exams.set(null);
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const exams = await db.exams
      .where('start')
      .aboveOrEqual(today)
      .sortBy('start');

    this._exams.set(exams);
  }

    async loadPastExams() {
    this._pastExams.set(null);
    
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const exams = await db.exams
      .where('start')
      .below(today)
      .sortBy('start');

    this._pastExams.set(exams);
  }


  async refreshExamsFromAPI(past = false): Promise<void> {
    let exams: IExamSession[] = [];
    let apiCallSucceeded = false;
    try {
      exams = await firstValueFrom(this.examsFromAPI.GetALLExamSessions(past));
      apiCallSucceeded = true;
    }
    catch (error) {
        console.log(error);
    }

    if (!apiCallSucceeded) {
      // API onbereikbaar: toon gewoon de lokale data zonder te wissen
      if (!past)
        await this.loadUpcomingExams();
      else
        await this.loadPastExams();
      return;
    }

    // Verwijder lokale examens die niet meer in de API zitten
    const apiIds = new Set(exams.map(e => e.examenslotID));
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const localExams = past
      ? await db.exams.where('start').below(today).toArray()
      : await db.exams.where('start').aboveOrEqual(today).toArray();

    const toDelete = localExams.filter(e => !apiIds.has(e.id)).map(e => e.id);
    if (toDelete.length > 0) {
      await db.transaction('rw', [db.scanHistory, db.examStudents, db.exams], async () => {
        for (const examId of toDelete) {
          await db.scanHistory.where('examId').equals(examId).delete();
          await db.examStudents.where('examId').equals(examId).delete();
        }
        await db.exams.bulkDelete(toDelete);
      });
    }

    for (let item of exams) {
      await this.createExam({
        id: item.examenslotID,
        degree: item.programmeName,
        name: item.courseName,
        start: new Date(`${item.examDate}T${item.startTime}`),
        end: new Date(`${item.examDate}T${item.endTime}`),
        extra: item.examenKans,
        room: "",
        duration: 0
      });
    }
    
    if (!past)
      await this.loadUpcomingExams();
    else
      await this.loadPastExams();
  }

  getExamById(id: string): IExam | undefined {
    
    let exam = (this._exams()??[]).find(e => e.id === id);
    if (exam == undefined)
      exam = (this._pastExams()??[]).find(e => e.id === id);
    return exam;
  }

  async createExam(exam: IExam)
  {
    const existing = await db.exams.get(exam.id);
    if (existing?.studentsCount != null) {
      exam.studentsCount = existing.studentsCount;
    }
    await db.exams.put(exam);
  }   
}
